import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/auth";
import Layout from "@/pages/layout";

export function ProtectedRoute() {
    const { isAuthenticated } = useAuth()
    const location = useLocation()
    if (isAuthenticated) {
        return (
            <>
                <Layout />
            </>
        )
    }

    return <Navigate to={`/login?redirect=${location.pathname}`} />

}
